import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for updateConfiguration mutation
 */
export interface UpdateConfigVariables {
  image_data?: string;
  configurationId: string;
  optionValue?: string;
}

/**
 * Updated configuration structure
 */
export interface UpdatedConfiguration {
  id: string;
  optionKey: string;
  optionScope: string;
  imageData: string | null;
}

/**
 * Update configuration payload structure
 */
export interface UpdateConfigurationPayload {
  configuration: UpdatedConfiguration;
}

/**
 * Response structure for updateConfiguration mutation
 */
export interface UpdateConfigResponse {
  updateConfiguration: UpdateConfigurationPayload;
}

const updateConfig: DocumentNode = gql`
  mutation configuration_update($image_data: String, $configurationId: ID!, $optionValue: String) {
    updateConfiguration(configurationId: $configurationId, imageData: $image_data, optionValue: $optionValue) {
      configuration {
        id
        optionKey
        optionScope
        imageData
      }
    }
  }
`;

export default updateConfig;
